import Vue from "vue";
import Component from "vue-class-component";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "MyWidgetApplication" })
export default class MyWidgetApplication extends Vue {
    public localizer: any = Localizer;
    public isLoading: boolean = false;
    public data: any = null;

    get routes() {
        return (<any>window).App.routes;
    }

    get isCatalogueSearchHide() {
        return this.$store.getters["catalogueSearchStore/isCatalogueSearchHide"];
    }

    public async created() {
        await this.getData();
    }

    public async getData() {
        this.isLoading = true;
        this.data = (await Axios.post(this.routes.MyBremboPartsDashboard_GetWidgetApplicationData, null)).data;
        this.isLoading = false;
    }

    public addFavorite() {
        this.$store.commit("catalogueSearchStore/setCatalogueSearchHidden", false);
        this.$store.commit("catalogueSearchStore/setCatalogueSearchMode", "Type");
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
};